<template>
    <div style="text-align:left">
        <Breadcrumb style="margin: 0px 10px 20px">
            <BreadcrumbItem to="/adAdmin">广告管理</BreadcrumbItem>
            <BreadcrumbItem>查看广告详情</BreadcrumbItem>
        </Breadcrumb>
        <div class="statistics">
            <br>
            <Row>
                <Col span="8">
                    <div class="box">
                        <div class="title">                     
                            投放天数
                        </div>
                        <div class="count">
                            {{put_days}}天
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            曝光次数
                        </div>
                        <div class="count">
                            {{show_count}}次
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="box">
                        <div class="title">
                            点击次数
                        </div>
                        <div class="count">
                            {{click_count}}次
                        </div>
                    </div>
                </Col>
            </Row>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">数据趋势</span>
            </Row>
            <Row class="row">
                <Col span="8">
                    <Select v-model="model" style="width:200px" @on-change="handleChange">
                        <Option value="show_count">曝光量</Option>
                        <Option value="click_count">点击数</Option>
                    </Select>
                </Col>
            </Row>
            <div id="echart"></div>
            <Row class="row" style="margin-top:0px">
                <span style="line-height:40px">历史数据统计</span>
            </Row>
            <Table :columns="columns" :data="historical_data" style="margin:20px">
            </Table>
            <Page show-total @on-change="changePage" style="margin-top: 10px; text-align: right" :total="total_count" :page-size="20"/>
            <br>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie';
import * as echarts from 'echarts';
import{getAdStatistics}from "@/request/api"
export default {
    name: 'adStatistics',
    components: {
        
    },
    data () {
        return {
            put_days: 12,
            show_count: '12万',
            click_count: '12万',
            model: 'show_count',
            show_connt_list: [],
            click_connt_list: [],
            date_list: [],
            data: [],
            chart_name: '曝光量',
            columns: [
                {
                    title: '日期',
                    key: 'date',
                    align: 'center'
                },
                {
                    title: '曝光次数',
                    key: 'show_count',
                    align: 'center'
                },
                {
                    title: '点击次数',
                    key: 'click_count',
                    align: 'center'
                }
            ],
            historical_data: [
                {
                    date: '2021年11月22日',
                    show_count: 12231,
                    click_count: 12231
                },
                {
                    date: '2021年11月21日',
                    show_count: 12231,
                    click_count: 12231
                },
            ],
            total_count: 2
        }
    },
    methods:{
        getData(...params){
            getAdStatistics({...params}).then(res=>{
                if(res.data.code==200){
                    console.log(res.data.data);
                    this.put_days=res.data.data.put_days
                    this.show_count=res.data.data.show_count
                    this.click_count=res.data.data.click_count
                    this.show_count_list=res.data.data.show_count_list
                    this.click_count_list=res.data.data.click_count_list
                    this.date_list=res.data.data.date_list 
                    this.data=res.data.data.show_count_list
                    this.drawChart()
                }else{
                    this.$Message.success(res.data.msg);
                }
            })
        },
        drawChart(){
            var Echart = echarts.init(document.getElementById('echart'));
            var option1  = {
                xAxis: {
                    type: 'category',
                    data: this.date_list
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data: this.data,
                    type: 'bar',
                    name: this.chart_name
                }],
                legend: {
                    show: true,
                    x:'center',
                    y:'bottom'
                },
                grid: {
                    top: 30
                },
                tooltip : {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                }
            };

            Echart.setOption(option1);
            window.addEventListener("resize", () => { Echart.resize();});
        },
        handleChange(value){
            if(value=='show_count'){
                this.chart_name = '曝光量'
                this.data = this.show_count_list
                this.drawChart()
            }else if(value=='click_count'){
                this.chart_name = '点击数'
                this.data = this.click_count_list
                this.drawChart()
            }
        },
        changePage(){}
    },
    created() {
        Cookies.set('active_name', '3');
        this.getData()
    },
    mounted(){
        Cookies.set('active_name', '1');
    }
}
</script>
<style scoped>
.banner{
  width: 100%;
  max-height: 120px;
  min-height: 120px;
  /* border:1px solid; */
  background: white;
}
.statistics{
  width: 100%;
  /* border:1px solid; */
  background: white;
  margin-top: 20px;
}
.row{
  margin: 10px 20px 10px;
}
.box{
  width: 200px;
  height: 120px;
  border:1px solid;
  margin: 0px 20px 20px;
}
.box .count{
  width: 100%;
  height: 70%;
  line-height: 60px;
  text-align: center;
  /* font-display: center; */
  font-size: 24px;
}
.box .title{
    text-align: left;
    font-size: 14px; 
    margin:10px 10px 0px;
}
#echart{
    margin:20px 20px 0px;
    width: 100%;
    height: 400px
}
</style>



// WEBPACK FOOTER //
// src/views/Ad/AdStatistics.vue